import { render } from "./UpdateEstate.vue?vue&type=template&id=5e5ec836"
import script from "./UpdateEstate.vue?vue&type=script&lang=js"
export * from "./UpdateEstate.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__